import React, { useState,useEffect,useContext } from "react";
// import { Row } from "react-bootstrap";
import { Table } from "react-bootstrap";
import Fade from "react-reveal/Fade";
import Dashboard from "../../components/Dashboard/Dashboard";
import { UserContext } from "../../components/UserContext";
import axios from "axios";
import "./styles.css";

const url = "https://www.bitmasta.io/php/functioned.php";
function Agents(props){
  const user = useContext(UserContext);
    const [refs,setRefs] = useState([])
    const [loading,setLoading] = useState(true)
    useEffect(() => {
      const fetchData = async () => {
          const formData = new FormData()
          formData.append("referrals",true)
          formData.append("Active_User",user.userDetails.Email)
          formData.append("code",user.userDetails.code)
          const res = await axios.post(url, formData)
          if(res){
            setRefs(res.data.Data)
            setLoading(false)
          }
      }

      if(user.userDetails)
      fetchData()
    }, [user])
    return (
      <Dashboard {...props} back={() => this.props.history.push("/dashboard")}>
        <Fade>
        {/* <h4 className="b7 text-center"> */}
        {refs ? !loading ?
        <Table responsive>
          <thead>
              <tr>
                  <th>S/N</th>
                  <th>Name</th>
                  <th>Email Address</th>
                  <th>Transaction Status</th>
              </tr>
            
          </thead>
            <tbody>
            {
              refs.map((ref,i)=>(
              <tr key={i}>
                  <td>{i+1}</td>
                  <td>{ref.user_name}</td>
                  <td>{ref.user_email}</td>
              <td>{ref.user_transact === "false" ? "none" : "success"}</td>
              </tr>
              )) 
            }
            
            </tbody>
        </Table> 
   : <p className="text-center">loading...</p> : <p className="text-center">No Referrals available</p>
   
   }
        </Fade>
      </Dashboard>
    );
  }

export default Agents;
